<template>
  <a
    class="wa-fab"
    :href="link"
    target="_blank"
    rel="noopener"
    aria-label="Chat with us on WhatsApp"
  >
    <svg viewBox="0 0 32 32" width="30" height="30" aria-hidden="true">
      <path
        fill="#fff"
        d="M16.04 4C9.94 4 5 8.94 5 15.04c0 1.96.51 3.87 1.49 5.55L4.9 27l6.58-1.72a11 11 0 0 0 4.55.98h.01c6.1 0 11.04-4.94 11.04-11.04C27.08 8.94 22.14 4 16.04 4Zm0 20.2h-.01a9.1 9.1 0 0 1-4.64-1.27l-.33-.2-3.9 1.02 1.04-3.8-.22-.35a9.13 9.13 0 0 1-1.4-4.86c0-5.05 4.11-9.16 9.17-9.16 2.45 0 4.75.96 6.48 2.69a9.1 9.1 0 0 1 2.68 6.48c0 5.06-4.11 9.16-9.15 9.16Zm5.02-6.86c-.28-.14-1.63-.8-1.88-.9-.25-.09-.43-.14-.61.14-.18.28-.7.9-.86 1.08-.16.18-.32.2-.6.07-.28-.14-1.16-.43-2.21-1.36-.82-.73-1.37-1.63-1.53-1.9-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.48.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.48-.07-.14-.61-1.48-.84-2.02-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.35-.25.28-.96.94-.96 2.28 0 1.35.98 2.65 1.12 2.83.14.18 1.93 2.95 4.68 4.14.65.28 1.16.45 1.56.58.66.21 1.26.18 1.73.11.53-.08 1.63-.67 1.86-1.31.23-.64.23-1.19.16-1.31-.07-.11-.25-.18-.53-.32Z"
      />
    </svg>
    <span class="wa-tip">Chat with us</span>
  </a>
</template>

<script>
import { whatsapp, whatsappMessage } from "@/data/contact";

export default {
  name: "WhatsAppButton",
  props: {
    // Singapore number in international format, no "+" or spaces
    phone: { type: String, default: whatsapp },
    message: { type: String, default: whatsappMessage },
  },
  computed: {
    link() {
      return `https://wa.me/${this.phone}?text=${encodeURIComponent(this.message)}`;
    },
  },
};
</script>
